export const DIRECTORY_SKELETON_IDS = [
  'directory-skeleton-1',
  'directory-skeleton-2',
  'directory-skeleton-3',
  'directory-skeleton-4',
  'directory-skeleton-5',
  'directory-skeleton-6',
  'directory-skeleton-7',
  'directory-skeleton-8',
] as const;

export const USER_DIRECTORY_PAGE_SIZE = 50;
